import { RecordsTable, type Column } from '../components/RecordsTable/RecordsTable';

interface AuditRow {
  id: number;
  actor_user_id: number | null;
  actor_label: string | null;
  action: string;
  target_type: string;
  target_id: number | null;
  created_at: string;
}

const COLUMNS: Column<AuditRow>[] = [
  { key: 'created_at', header: 'When' },
  { key: 'actor_label', header: 'Actor', render: (r) => r.actor_label ?? `user #${r.actor_user_id ?? '—'}` },
  { key: 'action', header: 'Action', render: (r) => <span className="records__tag">{r.action}</span> },
  { key: 'target_type', header: 'Target' },
  { key: 'target_id', header: 'Target ID', numeric: true, render: (r) => r.target_id ?? '—' },
];

export function Audit() {
  return (
    <RecordsTable<AuditRow>
      title="Audit"
      intro="A complete, append-only history of every write that flows through the MCP — who made the change, the action taken, the record it touched, and when. Entries can't be edited or deleted; newest first."
      tool="listAuditLog"
      args={{ limit: 200 }}
      select={(r) => (r as { entries: AuditRow[] }).entries ?? []}
      columns={COLUMNS}
      rowKey={(r) => r.id}
      emptyMessage="No audit entries yet."
      refreshable
    />
  );
}
